var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear())+" RALC365")]),_c('Social',{attrs:{"items":_vm.groupedPosts['personal-information'].meta.font_awesome}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }